import React from "react";
import { categoryTab, categoryTabCount } from "./categoryTabStyles";
import { scrollIntoContainer } from "../../utilities/scrollIntoContainer";

interface CategoryLinkProps {
    name: string;
    active: boolean;
    matchCount?: number;
    onSelect: () => void;
}

export const CategoryLink = (props: CategoryLinkProps) => {
    const { name, active, matchCount, onSelect } = props;
    const ref = React.useRef<HTMLDivElement>(null);

    React.useEffect(() => {
        if (active) {
            scrollIntoContainer(ref.current);
        }
    }, [active]);

    return (
        <div
            ref={ref}
            role="tab"
            aria-selected={active}
            tabIndex={active ? 0 : -1}
            onClick={onSelect}
            className={categoryTab(active, matchCount === 0)}
        >
            <span>{name}</span>
            {matchCount !== undefined && matchCount > 0 && <span className={categoryTabCount}>{matchCount}</span>}
        </div>
    );
};
